import React, { FC } from "react";
import styles from "./styles.module.less";
import classnames from "classnames";

export const PageFooter: FC<{
  style?: React.CSSProperties;
}> = () => {
  const icpRecord = window.__userPortalConfig__.icpRecord;
  const psbRecord = window.__userPortalConfig__.psbRecord;
  const poweredByConfig = window.__userPortalConfig__.poweredBy;

  return (
    <>
      <footer className={styles.pageFooter}>
        {poweredByConfig && (
          <div className={classnames("powered-by-authing", styles.poweredByAuthing)}>
            Powered by{" "}
            <a href={poweredByConfig?.link} target="_blank" rel="noopener noreferrer">
              <img width="56px" object-fit="contain" alt={poweredByConfig?.name} src={poweredByConfig?.logo} />
            </a>
          </div>
        )}
        {icpRecord && (
          <div className="authing-footer-icp-record" style={{ display: "none" }}>
            <a className={styles.footerLink} href="https://beian.miit.gov.cn" rel="noopener noreferrer" target="_blank">
              {icpRecord}
            </a>
          </div>
        )}
        {psbRecord && (
          <div className="authing-footer-psb-record" style={{ display: "none" }}>
            <a
              className={styles.footerLink}
              href={`http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=${psbRecord.match(/\d+/)?.[0]}`}
              rel="noopener noreferrer"
              target="_blank"
            >
              {psbRecord}
            </a>
          </div>
        )}
      </footer>
    </>
  );
};
